import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import http from '../services/httpService';
import useIsMounted from './useIsMounted';

export default function useAllDashboardBlogs() {
	const [dashboardBlogs, setDashboardBlogs] = useState(null);
	const { pathname } = useLocation();
	const isMounted = useIsMounted();

	useEffect(() => {
		const allowed = ['/dashboard/home', '/dashboard/news'];
		async function getBlogs() {
			try {
				if (
					!http.getCurrentUser() ||
					dashboardBlogs ||
					!allowed.includes(pathname)
				)
					return;
				const { data } = await http.getAllDashboardBlogs();
				if (isMounted()) setDashboardBlogs(data);
			} catch (error) {
				console.log('error :>> ', error);
			}
		}
		getBlogs();
	}, [isMounted, dashboardBlogs, pathname]);
	return [dashboardBlogs, setDashboardBlogs];
}
